import type { TranslationMessages } from "ra-core";

export const germanMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Filter hinzufügen",
      add: "Hinzufügen",
      back: "Zurück",
      bulk_actions:
        "1 Element ausgewählt |||| %{smart_count} Elemente ausgewählt",
      cancel: "Abbrechen",
      clear_array_input: "Liste leeren",
      clear_input_value: "Wert löschen",
      clone: "Duplizieren",
      confirm: "Bestätigen",
      create: "Anlegen",
      create_item: "%{item} anlegen",
      delete: "Löschen",
      edit: "Bearbeiten",
      export: "Exportieren",
      list: "Liste",
      refresh: "Aktualisieren",
      remove_filter: "Diesen Filter entfernen",
      remove_all_filters: "Alle Filter entfernen",
      remove: "Entfernen",
      reset: "Zurücksetzen",
      save: "Speichern",
      search: "Suchen",
      search_columns: "Spalten durchsuchen",
      select_all: "Alle auswählen",
      select_all_button: "Alle auswählen",
      select_row: "Diese Zeile auswählen",
      show: "Anzeigen",
      sort: "Sortieren",
      undo: "Rückgängig",
      unselect: "Auswahl aufheben",
      expand: "Ausklappen",
      close: "Schließen",
      open_menu: "Menü öffnen",
      close_menu: "Menü schließen",
      update: "Aktualisieren",
      move_up: "Nach oben",
      move_down: "Nach unten",
      open: "Öffnen",
      toggle_theme: "Hell-/Dunkelmodus wechseln",
      select_columns: "Spalten",
      update_application: "Anwendung neu laden",
    },
    boolean: {
      true: "Ja",
      false: "Nein",
      null: " ",
    },
    page: {
      create: "%{name} anlegen",
      dashboard: "Dashboard",
      edit: "%{name} %{recordRepresentation}",
      error: "Etwas ist schiefgelaufen",
      list: "%{name}",
      loading: "Wird geladen",
      not_found: "Nicht gefunden",
      show: "%{name} %{recordRepresentation}",
      empty: "Noch keine %{name} vorhanden.",
      invite: "Möchten Sie etwas anlegen?",
      access_denied: "Zugriff verweigert",
      authentication_error: "Anmeldefehler",
    },
    input: {
      file: {
        upload_several:
          "Dateien hierher ziehen oder klicken, um eine auszuwählen.",
        upload_single: "Datei hierher ziehen oder klicken, um sie auszuwählen.",
      },
      image: {
        upload_several:
          "Bilder hierher ziehen oder klicken, um eines auszuwählen.",
        upload_single: "Bild hierher ziehen oder klicken, um es auszuwählen.",
      },
      references: {
        all_missing: "Die verknüpften Daten konnten nicht gefunden werden.",
        many_missing:
          "Mindestens eine der Verknüpfungen ist nicht mehr verfügbar.",
        single_missing: "Die Verknüpfung ist nicht mehr verfügbar.",
      },
      password: {
        toggle_visible: "Passwort verbergen",
        toggle_hidden: "Passwort anzeigen",
      },
    },
    message: {
      about: "Über",
      access_denied: "Sie haben keine Berechtigung für diese Seite",
      are_you_sure: "Sind Sie sicher?",
      authentication_error:
        "Der Anmeldedienst hat einen Fehler gemeldet, Ihre Zugangsdaten konnten nicht geprüft werden.",
      auth_error: "Beim Prüfen des Anmeldetokens ist ein Fehler aufgetreten.",
      bulk_delete_content:
        "Möchten Sie %{name} wirklich löschen? |||| Möchten Sie diese %{smart_count} Elemente wirklich löschen?",
      bulk_delete_title: "%{name} löschen |||| %{smart_count} %{name} löschen",
      bulk_update_content:
        "Möchten Sie %{name} %{recordRepresentation} wirklich aktualisieren? |||| Möchten Sie diese %{smart_count} Elemente wirklich aktualisieren?",
      bulk_update_title:
        "%{name} %{recordRepresentation} aktualisieren |||| %{smart_count} %{name} aktualisieren",
      clear_array_input: "Möchten Sie die ganze Liste wirklich leeren?",
      delete_content: "Möchten Sie %{name} wirklich löschen?",
      delete_title: "%{name} %{recordRepresentation} löschen",
      details: "Details",
      error:
        "Es ist ein Fehler aufgetreten, Ihre Anfrage konnte nicht abgeschlossen werden.",
      invalid_form:
        "Das Formular ist nicht gültig. Bitte prüfen Sie die Eingaben",
      loading: "Bitte warten",
      no: "Nein",
      not_found:
        "Die Adresse ist falsch geschrieben oder der Link ist ungültig.",
      select_all_limit_reached:
        "Es gibt zu viele Elemente, um alle auszuwählen. Nur die ersten %{max} Elemente wurden ausgewählt.",
      unsaved_changes:
        "Einige Änderungen wurden nicht gespeichert. Möchten Sie sie wirklich verwerfen?",
      yes: "Ja",
      placeholder_data_warning:
        "Netzwerkproblem: Die Daten konnten nicht aktualisiert werden.",
    },
    navigation: {
      clear_filters: "Filter zurücksetzen",
      no_filtered_results: "Keine %{name} für die aktuellen Filter gefunden.",
      no_results: "Keine %{name} gefunden",
      no_more_results:
        "Die Seite %{page} liegt außerhalb des Bereichs. Versuchen Sie die vorherige Seite.",
      page_out_of_boundaries: "Seite %{page} liegt außerhalb des Bereichs",
      page_out_from_end: "Es gibt keine Seite nach der letzten",
      page_out_from_begin: "Es gibt keine Seite vor Seite 1",
      page_range_info: "%{offsetBegin}–%{offsetEnd} von %{total}",
      partial_page_range_info:
        "%{offsetBegin}–%{offsetEnd} von mehr als %{offsetEnd}",
      current_page: "Seite %{page}",
      page: "Zu Seite %{page}",
      first: "Zur ersten Seite",
      last: "Zur letzten Seite",
      next: "Zur nächsten Seite",
      previous: "Zur vorherigen Seite",
      page_rows_per_page: "Zeilen pro Seite:",
      skip_nav: "Zum Inhalt springen",
    },
    sort: {
      sort_by: "Nach %{field_lower_first} sortieren, %{order}",
      ASC: "aufsteigend",
      DESC: "absteigend",
    },
    auth: {
      auth_check_error: "Bitte melden Sie sich an, um fortzufahren",
      user_menu: "Profil",
      username: "Benutzername",
      password: "Passwort",
      email: "E-Mail",
      sign_in: "Anmelden",
      sign_in_error: "Anmeldung fehlgeschlagen, bitte erneut versuchen",
      logout: "Abmelden",
    },
    notification: {
      updated: "Element aktualisiert |||| %{smart_count} Elemente aktualisiert",
      created: "Element angelegt",
      deleted: "Element gelöscht |||| %{smart_count} Elemente gelöscht",
      bad_item: "Fehlerhaftes Element",
      item_doesnt_exist: "Element existiert nicht",
      http_error: "Fehler bei der Verbindung zum Server",
      data_provider_error:
        "Fehler im dataProvider. Details stehen in der Konsole.",
      i18n_error:
        "Die Übersetzungen für diese Sprache konnten nicht geladen werden",
      canceled: "Aktion abgebrochen",
      logged_out:
        "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.",
      not_authorized: "Sie haben keine Berechtigung für diese Ressource.",
      application_update_available: "Eine neue Version ist verfügbar.",
      offline: "Keine Verbindung. Daten konnten nicht geladen werden.",
    },
    validation: {
      required: "Pflichtfeld",
      minLength: "Muss mindestens %{min} Zeichen lang sein",
      maxLength: "Darf höchstens %{max} Zeichen lang sein",
      minValue: "Muss mindestens %{min} sein",
      maxValue: "Darf höchstens %{max} sein",
      number: "Muss eine Zahl sein",
      email: "Muss eine gültige E-Mail-Adresse sein",
      oneOf: "Muss einer dieser Werte sein: %{options}",
      regex: "Muss diesem Format entsprechen (regexp): %{pattern}",
      unique: "Muss eindeutig sein",
    },
    saved_queries: {
      label: "Gespeicherte Abfragen",
      query_name: "Name der Abfrage",
      new_label: "Aktuelle Abfrage speichern …",
      new_dialog_title: "Aktuelle Abfrage speichern als",
      remove_label: "Gespeicherte Abfrage entfernen",
      remove_label_with_name: 'Abfrage "%{name}" entfernen',
      remove_dialog_title: "Gespeicherte Abfrage entfernen?",
      remove_message:
        "Möchten Sie diesen Eintrag wirklich aus Ihren gespeicherten Abfragen entfernen?",
      help: "Liste filtern und diese Abfrage für später speichern",
    },
    guesser: {
      empty: {
        title: "Keine Daten vorhanden",
        message: "Bitte prüfen Sie Ihren dataProvider",
      },
    },
    configurable: {
      customize: "Anpassen",
      configureMode: "Diese Seite einrichten",
      inspector: {
        title: "Inspektor",
        content:
          "Fahren Sie über die Elemente der Oberfläche, um sie einzurichten",
        reset: "Einstellungen zurücksetzen",
        hideAll: "Alle ausblenden",
        showAll: "Alle anzeigen",
      },
      Datagrid: {
        title: "Tabelle",
        unlabeled: "Spalte ohne Bezeichnung #%{column}",
      },
      SimpleForm: {
        title: "Formular",
        unlabeled: "Feld ohne Bezeichnung #%{input}",
      },
      SimpleList: {
        title: "Liste",
        primaryText: "Haupttext",
        secondaryText: "Zweittext",
        tertiaryText: "Drittext",
      },
    },
  },
};

export const raSupabaseGermanMessages = {
  "ra-supabase": {
    auth: {
      email: "E-Mail",
      confirm_password: "Passwort bestätigen",
      sign_in_with: "Mit %{provider} anmelden",
      forgot_password: "Passwort vergessen?",
      reset_password: "Passwort zurücksetzen",
      password_reset:
        "Prüfen Sie Ihre E-Mails, dort finden Sie eine Nachricht zum Zurücksetzen des Passworts.",
      missing_tokens: "Access- und Refresh-Token fehlen",
      back_to_login: "Zurück zur Anmeldung",
    },
    reset_password: {
      forgot_password: "Passwort vergessen?",
      forgot_password_details:
        "Geben Sie Ihre E-Mail-Adresse ein, um Anweisungen zu erhalten.",
    },
    set_password: {
      new_password: "Wählen Sie Ihr Passwort",
    },
    validation: {
      password_mismatch: "Die Passwörter stimmen nicht überein",
    },
  },
};
